goog.provide("shadow.js.shim.module$$mui$material$TableContainer");
goog.provide("module$shadow_js_shim_module$$mui$material$TableContainer");
shadow.js.shim.module$$mui$material$TableContainer = shadow.js.nativeProvides["@mui/material/TableContainer"] = shadow$bridge("@mui/material/TableContainer");
module$shadow_js_shim_module$$mui$material$TableContainer.default = shadow.js.shim.module$$mui$material$TableContainer;
